import './style.scss'

const Alula = () => {
  return <div className='img-wrapper'>
    <img src="https://staticfile.badazhou.com/20240801/fba47b72e5754c7b6e72836eb0ed5153.png" alt="" />
  </div>
}

export default Alula